import art1 from "@assets/home/hero/art1.webp";
import art2 from "@assets/home/hero/art2.webp";
import art3 from "@assets/home/hero/art3.webp";
import art4 from "@assets/home/hero/art4.webp";
import art5 from "@assets/home/hero/art5.webp";
import avatar1 from "@assets/home/hero/avatar1.webp";
import avatar2 from "@assets/home/hero/avatar2.webp";
import avatar3 from "@assets/home/hero/avatar3.webp";
import avatar4 from "@assets/home/hero/avatar4.webp";
import avatar5 from "@assets/home/hero/avatar5.webp";
import imageSlider1 from "@assets/home/hero/ImageSlider1.png"
import imageSlider2 from "@assets/home/hero/imageSlider2.png"
import imageSlider3 from "@assets/home/hero/ImageSlider3.png"

const hero = [
  {
    id: "art-3",
    image: imageSlider1,
    title: "Detective investigating in a city",
    author: {
      name: "GraceParker",
      avatar: avatar3,
      isVerified: true,
    },
  },
  {
    id: "art-2",
    image: imageSlider2,
    title: "A boy writing a novel in a sunset",
    author: {
      name: "OliverMitchell",
      avatar: avatar2,
      isVerified: true,
    },
  },
  {
    id: "art-1",
    image: imageSlider3,
    title: "A cyborg taking over a city",
    author: {
      name: "SamanthaCollins",
      avatar: avatar1,
      isVerified: true,
    },
  },
  {
    id: "art-4",
    image: art4,
    title: "Jedi Knight and a cunning Sith acolyte",
    author: {
      name: "LucasBennett",
      avatar: avatar4,
      isVerified: true,
    },
  },
  {
    id: "art-5",
    image: art5,
    title: "Astronaut on a planet, with his spacecraft",
    author: {
      name: "EvelynHarper",
      avatar: avatar5,
      isVerified: true,
    },
  },
];

export default hero;
